import Icon from '../components/Icon.vue'

Icon.register({
  mosque: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 480C0 497.7 14.3 512 32 512H96C113.7 512 128 497.7 128 480V160H0V480zM579.2 288C597 270.6 608 250.7 608 229.1 608 176.2 566.2 135.3 520.1 106.2 478.1 79.7 439.5 48.4 408.1 10L400 0 391.9 10C360.6 48.4 321.9 79.7 279.9 106.2 233.8 135.3 192 176.2 192 229.1 192 250.7 203 270.6 220.8 288H579.2zM608 320H192C174.3 320 160 334.3 160 352V480C160 497.7 174.3 512 192 512H224V448C224 430.3 238.3 416 256 416S288 430.3 288 448V512H352V440C352 392 400 368 400 368S448 392 448 440V512H512V448C512 430.3 526.3 416 544 416S576 430.3 576 448V512H608C625.7 512 640 497.7 640 480V352C640 334.3 625.7 320 608 320zM64 0S0 32 0 96V128H128V96C128 32 64 0 64 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mosque.js
// module id = kbTH
// module chunks = 144